// ONE 플랫폼 공통 대화상자·모달 규칙 — 맨 먼저 불러 window keydown(Esc 는 맨 위 모달만)을
// 편집기·전역 키 가드보다 먼저 듣게 한다.
import './shell/oneUi';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/components.css';
// ONE 플랫폼 공통 모바일 대응 — 반드시 자기 CSS 뒤에 import
import './styles/one-mobile.css';
// ONE 플랫폼 공통 대화상자(one-ui 원본 사본) — 자기 CSS 뒤에
import './styles/one-ui.css';
import App from './App';
import { installGlobalKeyGuards } from './boot/keyboard';
import { setUnderlaySrcResolver } from './cad/render/underlayCache';
import { getUnderlaySignedUrl } from './data/uploadRepo';
import { trackUsage } from './data/usageRepo';

// iframe 안에서 브라우저/쉘 기본 단축키와 충돌하지 않도록 예약키를 선점한다.
installGlobalKeyGuards();

// 부착(Attach) 이미지 경로 → signed URL 변환. cad/render 계층은 Supabase 를
// 몰라야 하므로 여기서 한 번 주입한다(underlayCache.ts 상단 주석 참고).
setUnderlaySrcResolver(getUnderlaySignedUrl);

// 사용 로그 — 어떤 화면을 열었는지 수준만 남긴다(도면 데이터는 담지 않는다).
trackUsage('open', '진입');

const root = document.getElementById('root');
if (!root) throw new Error('#root 를 찾을 수 없습니다.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
